<template>
  <label :class="['checkbox', { disabled: disabled }]" data-testid="components-ui-checkbox-label">
    <input
      v-model="check"
      :value="modelValue"
      :checked="checked"
      name="checkbox"
      :disabled="disabled"
      :indeterminate="indeterminate"
      type="checkbox"
      @change="changeValue"
     data-testid="components-ui-checkbox-input">
    <span
      v-if="!indeterminate"
      class="checkbox__span"
    data-testid="components-ui-checkbox-span" />
    <div
      v-if="indeterminate"
      class="checkbox__indeterminate"
    data-testid="components-ui-checkbox-div" />
    {{ label }}
  </label>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, ref } from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Boolean, Array],
    default: false
  },
  label: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  checked: {
    type: Boolean,
    default: false
  },
  truckBy: {
    type: String,
    default: ''
  },
  index: {
    type: [String, Number],
    default: ''
  },
  item: {
    type: [Object, String],
    default: () => {
      return {
        id: ''
      };
    }
  },
  indeterminate: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue', 'change']);

const check = ref(props.checked);

const changeValue = () => {
  if (!props.disabled) {
    if (typeof props.modelValue === 'object') {
      let value = props.modelValue;

      if (check.value) {
        if (props.truckBy) {
          value.push(props.item[props.truckBy]);
        } else {
          value.push(props.item);
        }
      } else {
        value.splice(props.index, 1);
      }

      emit('update:modelValue', value);
      emit('change', props.item);
    } else {
      emit('update:modelValue', !props.modelValue);
      emit('change', !props.modelValue);
    }
  }
};
</script>

<style scoped lang="scss">
.checkbox {
  display: flex;
  align-items: center;
  width: max-content;
  font-size: 14px;
  white-space: nowrap;
  color: #292929;
  transition: 0.3s;
  font-weight: 600;
  line-height: 120%;
  cursor: pointer;
  gap: 8px;

  &::before {
    display: none;
  }

  &.disabled {
    cursor: default;
    color: #777b82;

    .checkbox__span {
      border-color: #828d9b;

      &::before {
        border-color: #828d9b;
      }
    }

    input:checked ~ .checkbox__span {
      background: #edeff3;
    }
  }

  input {
    display: none;
  }

  input:checked ~ .checkbox__span::before {
    transform: translate(-50%, -50%) rotateZ(45deg) scale(1);
  }

  &__span {
    position: relative;
    display: block;
    padding: 0 5px;
    height: 12px;
    background: #fff;
    border: 1px solid #3a7cca;
    border-radius: 2px;
    transition: 0.3s;
    box-sizing: border-box;

    &::before {
      content: '';
      position: absolute;
      top: 40%;
      left: 50%;
      border-right: 1.5px solid #3a7cca;
      border-bottom: 1.5px solid #3a7cca;
      width: 5px;
      height: 7px;
      transform: translate(-50%, -50%) rotateZ(45deg) scale(0);
      transition: 0.3s;
    }
  }

  &__indeterminate {
    position: relative;
    display: block;
    padding: 0 5px;
    height: 12px;
    background: #3A7CCA;
    border: 1px solid #3a7cca;
    border-radius: 2px;
    transition: 0.3s;
    box-sizing: border-box;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      border-radius: 1px;
      border: 1px solid #fff;
      width: 8px;
      height: 2px;
      transform: translate(-50%, -50%);
      transition: 0.3s;
    }
  }
}
</style>
